var common = require("../utiles/common");

module.exports = {
  register: function () {
    document.createElement("uch");
    ko.components.register("uch", {
      viewModel: function (params) {
        var $this = this;
        $this.switchUser = function () {
          var data = common.fetch("/auth/getUser", { type: "GET" }).data;
          $this.user = data;
          common.initStorage(data);
          sessionStorage.setItem("firstTime", "2");
        };
        // 判断是否刷新或者退出登录
        if (
          sessionStorage.getItem("firstTime") === "1" ||
          !sessionStorage.getItem("firstTime")
        ) {
          $this.switchUser();
        } else {
          $this.user = common.getStorage().user;
        }

        $this.hideFun = [];
        if (localStorage.getItem("authNode")) {
          var authNode = JSON.parse(localStorage.getItem("authNode"));
          console.log(authNode);
          if (authNode.hideFun && authNode.hideFun.length > 0) {
            $this.hideFun = authNode.hideFun;
          }
        }

        $this.updateTotal = function () {
          $this.total = ko.observable(0);
        };
        $this.updateTotal();
        console.log($this.user);
        $this.list = ko.observable(
          urlAddPrefix("/public/images/top_list1.png")
        );
        $this.jia = ko.observable(urlAddPrefix("/public/images/top_jia1.png"));
        $this.sc = ko.observable(urlAddPrefix("/public/images/top_sc1.png"));
        $this.zu = ko.observable(urlAddPrefix("/public/images/top_zu1.png"));
        $this.isActive = ko.observable();
        if (
          location.hash == "#/appList" ||
          location.hash == "#/appSort" ||
          location.hash.indexOf("appConfig") != -1 ||
          location.hash.indexOf("manageAuth") != -1 ||
          location.hash.indexOf("editAttr") != -1 ||
          location.hash.indexOf("recordIndex") != -1
        ) {
          $this.isActive("appList");
        } else if (
          location.hash == "#/workflow" ||
          location.hash == "#/accountApply" ||
          location.hash.indexOf("workflow") != -1
        ) {
          $this.isActive("workflow");
        } else {
          $this.isActive(location.hash.split("/")[1]);
        }
        $this.userDropMenu = {
          isDropMenuDisplay: ko.observable(false),
          className: "userDropMenu",
          items: [
            {
              icon: "\ue681",
              name: _i18n("用户信息"),
              action: function () {
                common.redirectTo("/#/userInfo");
              },
            },
            {
              icon: "\ue621",
              name: _i18n("修改密码"),
              action: function () {
                common.redirectTo("/#/updatePassword");
              },
            },
            // {
            //   icon: "\ue621",
            //   name: _i18n("生成二维码"),
            //   action: function () {
            //     common.redirectTo("/#/qrcode");
            //   },
            // },
            {
              icon: "\ue621",
              name: _i18n("操作日志"),
              action: function () {
                common.redirectTo("/#/actionLog");
              },
            },
            { name: "split" },
            {
              icon: "\ue60d",
              name: _i18n("退出登录"),
              action: function () {
                common.fetch("/auth/logout", {
                  method: "POST",
                  success: function (data) {
                    if (data.redirectUrl) {
                      common.redirectTo(data.redirectUrl);
                    } else {
                      localStorage.clear();
                      sessionStorage.clear();
                      sessionStorage.setItem("spnego", true);
                      sessionStorage.setItem("isWinLogout", true);
                      common.redirectTo("/#/login");
                    }
                  },
                });
              },
            },
          ],
        };
        $this.userList = ko.observableArray();
        if (
          $this.user.identitySwitch &&
          $this.user.subjectList &&
          $this.user.subjectList.length > 0
        ) {
          $this.userDropMenu.items.unshift({
            icon: "\ue681",
            name: "身份切换",
            action: function () {
              $this.userList($this.user.subjectList);
            },
          });
        }
        $this.workDropMenu = {
          isDropMenuDisplay: ko.observable(false),
          className: "userDropMenu",
          items: [
            {
              name: _i18n("流程审批"),
              action: function () {
                common.redirectTo("/#/workflow/pending");
              },
            },
          ],
        };
        $this.triggerUserDropMenu = function () {
          var old = $this.userDropMenu.isDropMenuDisplay();
          $this.userDropMenu.isDropMenuDisplay(!old);
        };
        $this.triggerWorkDropMenu = function () {
          var old = $this.workDropMenu.isDropMenuDisplay();
          $this.workDropMenu.isDropMenuDisplay(!old);
        };

        $this.active = ko.observable("");
        $this.setId = function (id) {
          console.log(id);
          $this.active(id);
        };

        $this.getHeaderLogo = function () {
          if (common.isZh()) {
            return localStorage.getItem("headerLogo");
          } else if (localStorage.getItem("logoImageEn")) {
            return localStorage.getItem("logoImageEn");
          }
          return "/public/images/logo_3.0.png";
        };
      },
      template: require("./UserCenterHeader.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/template/UserCenterHeader.js
// module id = 105
// module chunks = 0